<div class="tab-group">
  <a [routerLink]="workspaceRoute" class="tab-item" routerLinkActive="active">
     Workspace 
  </a>
  <a [routerLink]="insightsRoute" class="tab-item" routerLinkActive="active">
    Insights
  </a>
</div>
